'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return date.toISOString().replace(/T/, ' ').replace(/\..+/, '');
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/dateToGMTString.js
// module id = 55
// module chunks = 0